/* eslint-disable jsdoc/require-returns */
import * as React from 'react';

const pluginURL = window.pbc_facet_options.pluginURL;

/**
 * @name DTAdsMemberView
 */
const DTAdsMemberView = () => {
	return (
		<div className="dt-ads__content-title member">
			<div className="dt-ads__row">
				<div>
					<span>Download The New</span>
					<h2>Green Street News:<br />News & Deal Alerts App</h2>
				</div>

				<div className="dt-ads__download">
					<a className="dt-ads__appstore" href="https://apps.apple.com/us/app/deal-tracker/id1546206075" rel="noreferrer" target="_blank">
						<img src={ `${pluginURL}src/assets/dt-ads-appstore.png` } alt="Official Apple App Store button" />
					</a>

					<a className="dt-ads__gplay" href="https://play.google.com/store/apps/details?id=com.reactnews.dealtrackerapp" rel="noreferrer" target="_blank">
						<img src={ `${pluginURL}src/assets/dt-ads-gplay.png` } alt="Official Google Play Store button" />
					</a>
				</div>
			</div>
		</div>
	);
};

export default DTAdsMemberView;
